var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyclipboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.202,
    height: 12.596,
    viewBox: "0 0 12.202 12.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49372",
    "data-name": "Group 49372",
    transform: "translate(12698.374 -20351.012)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-copy-4646098",
    d: "M144.576,1.968a1.387,1.387,0,0,0-1.525,1.181v8.266a1.387,1.387,0,0,0,1.525,1.181h6.1a1.387,1.387,0,0,0,1.525-1.181V3.148a1.387,1.387,0,0,0-1.525-1.181Zm0,.787h6.1a.462.462,0,0,1,.508.394v8.266a.462.462,0,0,1-.508.394h-6.1a.462.462,0,0,1-.508-.394V3.148A.462.462,0,0,1,144.576,2.755ZM141.525,0a1.431,1.431,0,0,0-1.518,1.067L140,1.18V9.84h1.017V1.18a.438.438,0,0,1,.417-.387l.091-.006h7.118V0Z",
    transform: "translate(-12838.374 20351.012)",
    fill: "#ebebeb",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyclipboard);
export default __webpack_public_path__ + "static/media/copyclipboard.29cc499b786429cf5984e61a0048565f.svg";
export { ForwardRef as ReactComponent };